import React from "react";
import Root from "./components/Root";

export default function App() {
  return <Root/>;
}